import { registerBlockType } from '@wordpress/blocks';
import metadata from './block.json';
import Edit from './Edit';
import Save from './save';

registerBlockType( metadata.name, {
	edit: Edit,
	save: Save,
	icon: {
		foreground: '#0061FE',
		src: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				width="24"
				height="24"
			>
				{ /* A row of slots, the middle one caught mid-swap. */ }
				<rect
					x="2"
					y="9"
					width="5"
					height="6"
					rx="1"
					fill="currentColor"
				/>
				<rect
					x="9.5"
					y="6"
					width="5"
					height="6"
					rx="1"
					fill="currentColor"
					opacity=".25"
				/>
				<rect
					x="9.5"
					y="13"
					width="5"
					height="6"
					rx="1"
					fill="currentColor"
				/>
				<rect
					x="17"
					y="9"
					width="5"
					height="6"
					rx="1"
					fill="currentColor"
				/>
			</svg>
		),
	},
} );
